import { css, modifier, styled } from '@lokalise/styled';

import { color, radius, spacing, typography } from '@app/theme';

export const UploadErrorMessage = styled.div`
    color: ${color('text.danger')};

    display: flex;
    align-items: center;
    gap: ${spacing(2)};
`;

export const UploadRemovingMessage = styled.div`
    ${typography('body.caption')}

    display: flex;
    align-items: center;
    gap: ${spacing(2)};
`;

export const UploadProgressBarWrapper = styled.div<{
    $success?: boolean;
    $pending?: boolean;
}>`
    display: flex;
    align-items: center;
    gap: ${spacing(2)};
    flex: 1 1 auto;

    & .style-guide-upload-progress > div,
    & .style-guide-upload-progress {
        height: 4px;
        border-radius: ${radius('rounded')};
    }

    & .style-guide-upload-progress > div {
        transition: width 0.2s ease-in-out;
        background-color: ${color('text.default')};
    }

    & > svg {
        scale: 0;
        transition: scale 150ms ease-in-out;
    }

    ${modifier(
        '$success',
        css`
            & > svg {
                scale: 1;
                color: ${color('text.success')};
            }

            & .style-guide-upload-progress > div {
                background-color: ${color('text.success')};
            }
        `,
    )}

    ${modifier(
        '$pending',
        css`
            & .style-guide-upload-progress > div {
                background-color: ${color('text.disabled')};
            }
        `,
    )}
`;
